import React from 'react';
import App from './App';
import './App.css';
import ReactDOM from 'react-dom/client'; // Correct import for React 18+

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

